<template>
    <div class="text-center">
        <IconComp
            v-if="props.value === true"
            icon="fa-check-circle"
            class="text-success"
        />
        <IconComp
            v-else-if="props.value === false && props.dontShowFalse === false"
            icon="fa-times-circle"
            class="text-danger"
        />
    </div>
</template>
<script setup lang="ts">
import { IconComp } from '@/components';

const props = defineProps<{
    value?: boolean;

    /**
     * Dont render a icon if the value is false
     */
    dontShowFalse?: boolean;
}>();
</script>
